<script setup lang="ts">
// One row of a List, over DataRow. `unread` marks it with the accent; `interactive`
// adds the hover tint, and `click` fires on the row (Enter too).
import DataRow from './DataRow.vue';

withDefaults(defineProps<{ title?: string | undefined; meta?: string | undefined; unread?: boolean; interactive?: boolean }>(), { unread: false, interactive: false });
const emit = defineEmits<{ click: [] }>();
</script>

<template>
  <li class="itc-list-item" :class="{ 'itc-list-item--unread': unread }">
    <DataRow
      :title="title"
      :meta="meta"
      :interactive="interactive"
      :tabindex="interactive ? 0 : undefined"
      @click="interactive && emit('click')"
      @keydown.enter="interactive && emit('click')"
    >
      <template v-if="$slots.start || unread" #start>
        <slot name="start">
          <span class="itc-dot itc-list-item__dot t-accent" aria-hidden="true"></span>
        </slot>
      </template>
      <template v-if="$slots.default" #default><slot /></template>
      <template v-if="$slots.end" #end><slot name="end" /></template>
    </DataRow>
  </li>
</template>

<style scoped>
.itc-list-item {
  border-bottom: 1px solid var(--itc-line);
}
.itc-list-item:last-child {
  border-bottom: 0;
}
.itc-list-item :deep(.itc-data-row) {
  border-bottom: 0;
}
.itc-list-item__dot {
  width: 8px;
  height: 8px;
}
.itc-list-item--unread :deep(.itc-data-row__title) {
  font-weight: 700;
}
</style>
